import React from 'react';
import { DownloadStatusData } from '../../models/invoices/DownloadStatusResponse';

interface InvoiceDownloaderProgressProps {
  downloadStatus: DownloadStatusData;
}

export const InvoiceDownloaderProgress: React.FC<
  InvoiceDownloaderProgressProps
> = ({ downloadStatus }) => {
  const calculatePercentage = (completed: number, total: number) => {
    return total > 0 ? Math.round((completed / total) * 100) : 0;
  };

  return (
    <div className="max-w-4xl py-4 space-y-4">
      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <span className="text-sm font-medium">
            Invoices: {downloadStatus.completedInvoices} of{' '}
            {downloadStatus.totalInvoices} completed
          </span>
          <span className="text-sm text-base-content/70">
            {calculatePercentage(
              downloadStatus.completedInvoices,
              downloadStatus.totalInvoices,
            )}
            %
          </span>
        </div>
        <progress
          className="progress progress-primary w-full"
          value={calculatePercentage(
            downloadStatus.completedInvoices,
            downloadStatus.totalInvoices,
          )}
          max="100"
        ></progress>
      </div>
      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <span className="text-sm font-medium">
            Direct Downloads: {downloadStatus.completedDirect} of{' '}
            {downloadStatus.totalDirect} completed
          </span>
          <span className="text-sm text-base-content/70">
            {calculatePercentage(
              downloadStatus.completedDirect,
              downloadStatus.totalDirect,
            )}
            %
          </span>
        </div>
        <progress
          className="progress progress-warning w-full"
          value={calculatePercentage(
            downloadStatus.completedDirect,
            downloadStatus.totalDirect,
          )}
          max="100"
        ></progress>
      </div>
      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <span className="text-sm font-medium">
            Telephone Downloads: {downloadStatus.completedTelephone} of{' '}
            {downloadStatus.totalTelephone} completed
          </span>
          <span className="text-sm text-base-content/70">
            {calculatePercentage(
              downloadStatus.completedTelephone,
              downloadStatus.totalTelephone,
            )}
            %
          </span>
        </div>
        <progress
          className="progress progress-secondary w-full"
          value={calculatePercentage(
            downloadStatus.completedTelephone,
            downloadStatus.totalTelephone,
          )}
          max="100"
        ></progress>
      </div>
    </div>
  );
};
